export default "__VITE_ASSET__26f303a5__"